var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { css } from 'styled-components';
import "../../themes/alert.js";
import { borderRadiusMedium } from "../../themes/borders.js";
import "../../themes/button.js";
import "../../themes/checkbox.js";
import "../../themes/divider.js";
import "../../themes/dropdown.js";
import "../../themes/fieldset.js";
import { fontFamilyBook } from "../../themes/fonts.js";
import "../../themes/input.js";
import "../../themes/list.js";
import "../../themes/listbox.js";
import "../../themes/loader.js";
import "../../themes/option.js";
import "../../themes/popout.js";
import "../../themes/switch.js";
import "../../themes/themes.js";
import "../../themes/tooltip.js";
var baseAlertStyle = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: transparent;\n  border-color: transparent;\n  border-radius: ", "px;\n  border-style: solid;\n  border-width: 1px;\n  box-sizing: border-box;\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 22px;\n  overflow-wrap: anywhere;\n  padding: 15px;\n"])), borderRadiusMedium, fontFamilyBook);
/**
 * Get Styled Component alert theme
 * @param options GetAlertThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getAlertTheme = function getAlertTheme(options) {
  var look = options.look;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n\n    .bf-alert__icon {\n      color: ", ";\n    }\n\n    .bf-button__close {\n      background-color: ", ";\n      border-color: ", ";\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n\n      &:focus-visible {\n        color: ", ";\n        outline-color: ", ";\n      }\n    }\n  "])), function (_ref) {
    var theme = _ref.theme;
    return theme.alert[look].backgroundColor;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.alert[look].borderColor;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.alert[look].textColor;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.alert[look].iconColor;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.alert[look].backgroundColor;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.alert[look].backgroundColor;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.alert[look].iconColor;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.alert[look].iconColorHover;
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.alert[look].iconColorHover;
  }, function (_ref10) {
    var theme = _ref10.theme;
    return theme.alert[look].iconColorHover;
  });
};
/**
 * Get Styled Component inline alert theme
 * @param options GetAlertThemeOptions
 * @returns ThemedCssFunction<DefaultTheme>
 */
var getInlineAlertTheme = function getInlineAlertTheme(options) {
  var look = options.look;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), function (_ref11) {
    var theme = _ref11.theme;
    return theme.alert[look].textColorInline;
  });
};
export { baseAlertStyle, getAlertTheme, getInlineAlertTheme };